import { render, staticRenderFns } from "./LinkPreview.vue?vue&type=template&id=c5d6638a&scoped=true&"
import script from "./LinkPreview.vue?vue&type=script&lang=js&"
export * from "./LinkPreview.vue?vue&type=script&lang=js&"
import style0 from "./LinkPreview.vue?vue&type=style&index=0&id=c5d6638a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d6638a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow})
